import "text-encoding-polyfill";
import Joi from "joi";

const createCardFirstStepSchema = Joi.object({
	institution: Joi.string().required(),
	studentId: Joi.string().min(3).max(20).required(),
	dob: Joi.string().required(),
});

export default createCardFirstStepSchema;
